export default {"src":"/_next/static/media/snowboard.e4ce1663.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};